function getUrlParamsArray(url) {
    var queryString = url ? url.split('?')[1] : window.location.search.substring(1);
    var urlParams = queryString ? queryString.split('&') : null;
    return urlParams;
}
function paramArrayToString(params) {
    var string = '';
    params.forEach(function (item, index, array) {
        if (index === array.length - 1) {
            string += item;
        } else {
            string += item + '&';
        }
    });
    return string;
}
function getUrlParameter(searchedParam, queryString) {
    var url = queryString || window.location.search.substring(1);
    var urlParams = url.split('&');
    var urlParam;
    var paramString = urlParams.find(function (param) {
        return param.indexOf(searchedParam + '=') === 0;
    });
    if (typeof paramString !== 'undefined') {
        urlParam = paramString.split('=');
        if (typeof urlParam[1] !== 'undefined') {
            return decodeURIComponent(urlParam[1]);
        }
    }
    return null;
}
function updateParamInQueryString(queryString, param, value) {
    var reg = new RegExp('\\b' + param + '=([^&]+)');
    var updatedQueryString;
    if (reg.test(queryString)) {
        updatedQueryString = queryString.replace(reg, param + '=' + value);
    }
    return updatedQueryString || queryString;
}
function removeParamInQueryString(queryString, param) {
    var reg = new RegExp('\\b' + param + '=([^&]+)', 'g');
    var updatedQueryString = queryString;
    if (reg.test(queryString)) {
        var matches = queryString.match(reg);
        matches.forEach(function (item) {
            var itemReg = new RegExp('\\b&?' + item + '&?');
            if (updatedQueryString.match(itemReg).index === updatedQueryString.length - item.length - 1 || updatedQueryString.match(itemReg).index === 0) {
                updatedQueryString = updatedQueryString.replace(itemReg, '');
            } else {
                updatedQueryString = updatedQueryString.replace(itemReg, '&');
            }
        });
        return updatedQueryString;
    }
    return queryString;
}
function removeStartSzParams(queryString) {
    var reg = new RegExp('(start|sz)(=([^&]+))?', 'g');
    var updatedQueryString = queryString;
    if (reg.test(queryString)) {
        var matches = queryString.match(reg);
        matches.forEach(function (item) {
            var itemReg = new RegExp('&?' + item + '&?');
            if (updatedQueryString.match(itemReg).index === updatedQueryString.length - item.length - 1 || updatedQueryString.match(itemReg).index === 0) {
                updatedQueryString = updatedQueryString.replace(itemReg, '');
            } else {
                updatedQueryString = updatedQueryString.replace(itemReg, '&');
            }
        });
    }
    return updatedQueryString;
}
function removeFilterParams(queryString) {
    var reg = new RegExp('(cgid|prefn[0-9]|prefv[0-9]|pmin|pmax|srule)(=([^&]+))?', 'g');
    var updatedQueryString = queryString;
    if (reg.test(queryString)) {
        var matches = queryString.match(reg);
        matches.forEach(function (item) {
            var itemReg = new RegExp('&?' + item + '&?');
            if (updatedQueryString.match(itemReg).index === updatedQueryString.length - item.length - 1 || updatedQueryString.match(itemReg).index === 0) {
                updatedQueryString = updatedQueryString.replace(itemReg, '');
            } else {
                updatedQueryString = updatedQueryString.replace(itemReg, '&');
            }
        });
    }
    return updatedQueryString;
}
function updateOrAddParamToQuerystring(param, value, queryString) {
    var paramsArray = queryString.split('&');
    var newQuerystring;
    if (!paramsArray || paramArrayToString(paramsArray) === '') {
        newQuerystring = param + '=' + value;
    } else if (getUrlParameter(param, queryString)) {
        newQuerystring = updateParamInQueryString(paramArrayToString(paramsArray), param, value);
    } else {
        newQuerystring = paramArrayToString(paramsArray) + '&' + param + '=' + value;
    }
    return newQuerystring || null;
}

function updateUrlFilterParams(newFilterParams) {
    var newQuerystring = window.location.search.substring(1);
    newQuerystring = removeParamInQueryString(newQuerystring, 'page');
    newQuerystring = removeFilterParams(newQuerystring);
    if (newFilterParams) {
        newFilterParams.forEach(function (element) {
            var param = element.split('=');
            newQuerystring = updateOrAddParamToQuerystring(param[0], param[1], newQuerystring);
        });
    }
    newQuerystring = removeStartSzParams(newQuerystring);
    if (window.location.hash) {
        newQuerystring += decodeURIComponent(window.location.hash);
    }
    if (newQuerystring) {
        window.history.replaceState(null, null, '?' + newQuerystring);
    } else {
        window.history.replaceState(null, null, '');
    }
}
function updatePageParam(count) {
    var newQuerystring = '?' + updateOrAddParamToQuerystring('sz', count, window.location.search.substring(1));
    if (window.location.hash) {
        newQuerystring += decodeURIComponent(window.location.hash);
    }
    window.history.replaceState(null, null, newQuerystring);
}

module.exports = {
    getUrlParamsArray             : getUrlParamsArray,
    paramArrayToString            : paramArrayToString,
    getUrlParameter               : getUrlParameter,
    updateParamInQueryString      : updateParamInQueryString,
    removeFilterParams            : removeFilterParams,
    removeStartSzParams           : removeStartSzParams,
    removeParamInQueryString      : removeParamInQueryString,
    updateOrAddParamToQuerystring : updateOrAddParamToQuerystring,
    updatePageParam               : updatePageParam,
    updateUrlFilterParams         : updateUrlFilterParams
};
